import React, {useState, useRef, useEffect} from 'react';
import {
   View,
   SafeAreaView,
   Image,
   StyleSheet,
   Dimensions,
   ImageBackground,
   Text,
   TouchableOpacity,
   ActivityIndicator,
   Platform,
} from 'react-native';
import {
   downloadViewColor,
   hour_Level,
   moduleComplitedPercentage,
   module_Level,
   trainingValidity_Level,
   FONT_FAMILY_REGULAR,
   RESET_ACCOUNT,
   UNLOCK_COURSE,
   isDownloadAllowed,
   isNewAPI,
   alertWithCallBack,
   FONT_FAMILY_MEDIUM,
   isWeb,
   WHITE_ICON_HOVER_TINT_COLOR,
   WHITE_TEXT_HOVER_COLOR,
   white,
} from '../../utils/utils';
import CourseDetailList from './CourseDetailList';
import {
   drawerListBackgroundColor,
   courseDesciptionContainerColor,
} from '../../utils/utils';
import CourseDetailItem from './CourseDetailItem';
import {
   couurseDetailButtonColor,
   courseListBGColor,
   coureListGradientColorLower,
   coureListGradientColorMiddle,
   coureListGradientColorUpper,
   getCourseProgressLevel,
   OFFLINE_VIDEO_PATH,
   redirectToBrowser,
} from '../../utils/utils';
//import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import {useIsFocused, useNavigation} from '@react-navigation/native';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import {
   getIsTabletPortrait,
   getShowLandscapeMsg,
   selectLandscapeSmallWebView,
   selectScreenOrientation,
   setIsLandscapemode,
} from '../../redux/slices/ScreenOrientationSlice';
import {PopoverLandscape} from '../../utils/popoverView';
import {CourseSupport} from '../../utils/courseSupport';
import {ActionSheetCourseSupport} from '../../utils/actionSheetCustomSupport';
import {primaryColor500} from '../../utils/utils';
import {removeSaveItem} from '../../utils/preference';
import {useDispatch, useSelector} from 'react-redux';
import {setReviewQuestionAnswer} from '../../redux/slices/ReviewQuestionsSlice';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import {
   selectedModuleIndex,
   setModuleIndex,
} from '../../redux/slices/ModuleIndexSlice';
import {setCourseId} from '../../redux/slices/CourseIdSlice';
//import RNFS from 'react-native-fs';
import RNFS from '../../components/fs';
//import ZipArchive from 'react-native-zip-archive';
import DownloadThreeDotsLoader from '../../utils/download_loading';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
const {width, height} = Dimensions.get('window');
const widthWeb = window.innerWidth;
import logger from '../../utils/logger';
import {
   getResponseAlertData,
   setResponseAlertData,
} from '../../redux/slices/ResponseAlertSlice';
import {setIsDashboardRefreshRequired} from '../../redux/slices/DashboardRefreshSlice';
import {canPreTest} from '../../utils/course_utils';
import {selectedScratchPadRecord} from '../../redux/slices/ScratchPadRecordSlice';

const Header = props => {
   const {width, height} = Dimensions.get('window');
   const handleImageLoadHeader = () => {
      setLoading(false);
   };
   const [loading, setLoading] = useState(true);
   const item = props.trainingItem;
   let copiedObject = Object.assign({}, item);
   const moduleLevel = module_Level(item);
   const hourLevel = hour_Level(item);
   const courseValidityLevel = trainingValidity_Level(item);
   var mPercent = moduleComplitedPercentage(item);
   const isLandscapemode = useSelector(selectScreenOrientation);
   const scratchPadString = useSelector(selectedScratchPadRecord);
   const scratchPad = JSON.parse(scratchPadString);
   const moduleIndex = useSelector(selectedModuleIndex);
   let runningModuels;
   if (props.module) {
      const modules = props.module;
      if (Array.isArray(modules)) {
         runningModuels = modules[moduleIndex];
      } else {
         runningModuels = modules;
      }
   }
   const scratchPadRecord = isNewAPI
      ? scratchPad.ScratchPadRecordsList
      : scratchPad.scratchPadRecord;
   var currentProgress;
   try {
      const fiterData = scratchPadRecord.filter(data => {
         const parseIndex = parseInt(moduleIndex) + 1;
         const parseModuleNumber = parseInt(data.ModuleNumber);
         logger('filter', {value: parseModuleNumber == parseIndex});
         return parseModuleNumber == parseIndex;
      });
      if (fiterData[0].ModuleCompleted != 1) {
         const mPageNumber = fiterData[0].ModulePageNumber;
         copiedObject.pageNumber = mPageNumber;
         if (runningModuels && copiedObject.pageCount == 0) {
            copiedObject.pageCount =
               runningModuels?.ModuleSlides?.CourseModuleSlide?.length;
         }
      }
      currentProgress = getCourseProgressLevel(copiedObject, width - 16 * 2);
   } catch (error) {
      currentProgress = getCourseProgressLevel(item, width - 16 * 2);
   }

   return (
      <View
         style={[
            styles.headerContainer,
            {
               ...Platform.select({
                  web: {
                     backgroundColor: 'transparent',
                  },
               }),
            },
         ]}>
         {/** Header title Section with gradient view, logo, title and description */}
         {/* <View style={styles.headerTitleContainer}> */}

         <View style={[styles.headerImageContainer]}>
            {loading && (
               <ActivityIndicator
                  size="small"
                  color="white" //No Change
                  style={{
                     position: 'absolute',
                     top: 0,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     zIndex: 1,
                  }}
               />
            )}
            <UISvg
               height="100%"
               width="100%"
               x1="0%"
               y1="100%"
               x2="0%"
               y2="0%"
               offset={['30%', '100%']}
               stopColor={['#000000', '#000000']}
               stopOpacity={['0.8', '0.1']}
            />
            <ImageBackground
               style={[
                  styles.bgImage,
                  {
                     opacity: isLandscapemode ? null : 0.5,
                     height: width * 0.56,
                  },
               ]}
               source={{uri: item.coursethumbnail}}
               onLoadEnd={handleImageLoadHeader}>
               {/* <Svg
                  height="100%"
                  width="100%"
                  style={StyleSheet.absoluteFillObject}>
                  <Defs>
                     <LinearGradient
                        id="grad"
                        x1="0%"
                        y1="100%"
                        x2="0%"
                        y2="0%">
                        <Stop
                           offset="0%"
                           stopColor={drawerListBackgroundColor}
                           stopOpacity="1"
                        />
                        <Stop
                           offset="100%"
                           stopColor={drawerListBackgroundColor}
                           stopOpacity="0"
                        />
                     </LinearGradient>
                  </Defs>
                  <Rect width="100%" height="100%" fill="url(#grad)" />
               </Svg> */}
            </ImageBackground>
            <View
               style={{
                  // marginTop: 38,
                  // marginBottom: 38,
                  marginLeft: 17,
                  marginRight: 17,
                  justifyContent: 'center',
                  height: width * 0.56,
               }}>
               <Text style={styles.courseTitle}>{props.title}</Text>
               <Text style={styles.courseDescription}>{props.description}</Text>
            </View>
         </View>

         {/** Header description Section */}
         <View
            style={[
               styles.headerDescriptionContainer,
               {
                  marginHorizontal: isLandscapemode ? 24 : 16,
               },
            ]}>
            {/** Header module icons sections */}
            <View style={{flexDirection: 'row', marginTop: 17}}>
               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/course_hightlight_24.png')}
                     style={styles.moduleIcon}
                  />
                  <Text style={styles.moduleDescription}>{moduleLevel}</Text>
               </View>

               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/Timer.png')}
                     style={styles.moduleIcon}
                  />
                  <Text style={styles.moduleDescription}>{hourLevel}</Text>
               </View>
               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/Check.png')}
                     style={styles.moduleIcon}
                  />
                  <Text style={styles.moduleDescription}>
                     {courseValidityLevel}
                  </Text>
               </View>
            </View>

            {/** Title and progress section */}
            {/** parent view of title */}
            <View
               style={{
                  flex: 1,
               }}>
               <View
                  style={{
                     flex: 1,
                     flexDirection: 'row',
                     justifyContent: 'space-between',
                  }}>
                  <View
                     style={{
                        width: width * 0.6,
                        marginTop: 9,
                        ...Platform.select({
                           web: {
                              width: '60%',
                           },
                        }),
                     }}>
                     <Text
                        style={[
                           styles.availableModulePortraitTitle,
                           {paddingTop: 8},
                        ]}>
                        {'Available Modules'}
                     </Text>
                     <Text style={styles.moduleAvailableDescription}>
                        {
                           'Please select a module to begin or continue with your training'
                        }
                     </Text>
                  </View>

                  <View
                     style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...Platform.select({
                           web: {
                              justifyContent: 'space-between',
                              width: '40%',
                           },
                        }),
                     }}>
                     <View
                        style={{
                           alignItems: 'center',
                           justifyContent: 'center',
                           ...Platform.select({
                              web: {
                                 width: '100%',
                                 alignItems: 'flex-end',
                              },
                           }),
                        }}>
                        <View
                           style={{
                              width: '10%',
                              justifyContent: 'center',
                              marginRight: 16,
                              marginLeft: 4,
                              maxHeight: 40,
                              marginTop: 8,
                              alignItems: 'center',
                              ...Platform.select({
                                 web: {
                                    width: '100%',
                                    marginLeft: 4,
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end',
                                    marginRight: 0,
                                 },
                              }),
                           }}>
                           <Text
                              style={[
                                 styles.moduleCompletedCount,
                                 {
                                    width: isLandscapemode ? '100%' : '50%',
                                    ...Platform.select({
                                       web: {
                                          textAlign: 'right',
                                          paddingRight: 8,
                                          paddingBottom: 6,
                                       },
                                    }),
                                 },
                              ]}>
                              {item.modulesCompleted}/{item.coursemodulecount}
                           </Text>
                           {/* <AnimatedCircularProgress
                           size={40}
                           width={3}
                           fill={mPercent}
                           rotation={0}
                           tintColor="#26E555"
                           backgroundColor="#1C222B">
                           {fill => (
                              <View
                                 style={{
                                    width: '100%',
                                    height: '100%',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: '#1C222B',
                                    opacity: 0.6,
                                 }}>
                                 <Image
                                    source={require('../../assets/course_hightlight_24.png')}
                                    style={{width: 17, height: 18}}
                                 />
                              </View>
                           )}
                        </AnimatedCircularProgress> */}
                           <UICircularProgress
                              size={24}
                              width={10}
                              fill={mPercent}
                              rotation={0}
                              tintColor="#26E555"
                              backgroundColor="#1C222B"
                              img={require('../../assets/course_hightlight_24.png')}
                              imgWidth={12}
                              imgHeight={12}
                              trailStroke="#1C222B"
                              showPercent={false}
                              background={true}
                              applyPadding={true}
                           />
                        </View>
                        <Text style={[styles.moduleCompleted, {marginTop: 0}]}>
                           {'Module Completed'}
                        </Text>
                     </View>
                  </View>
               </View>

               <View
                  style={{
                     width: width - 16 * 2,
                     background: 'rgba(217, 217, 217, 8)',
                     borderRadius: 10,
                     borderWidth: 0.25,
                     borderColor: 'lightgray',
                     marginVertical: 8,
                     ...Platform.select({
                        web: {
                           width: '100%',
                        },
                     }),
                  }}>
                  <View
                     style={{
                        width: currentProgress,
                        height: 4,
                        backgroundColor: '#26E555',
                        borderRadius: 10,
                        justifyContent: 'center',
                        ...Platform.select({
                           web: {
                              width: `${
                                 (currentProgress / (width - 16 * 2)) * 100
                              }%`,
                              maxWidth: '100%',
                           },
                        }),
                     }}
                  />
               </View>
            </View>
         </View>

         {/** Spacer View */}
         <View
            style={{
               width: Platform.OS !== 'web' ? '100%' : 'inherit',
               height: 8,
               backgroundColor: 'transparent',
            }}
         />
      </View>
   );
};

const HeaderLandScape = (props, isLandscape) => {
   var item = props.trainingItem;
   let copiedObject = Object.assign({}, item);
   const moduleLevel = module_Level(item);
   const hourLevel = hour_Level(item);
   const courseValidityLevel = trainingValidity_Level(item);
   var mPercent = moduleComplitedPercentage(item);
   const scratchPadString = useSelector(selectedScratchPadRecord);
   const scratchPad = JSON.parse(scratchPadString);
   const moduleIndex = useSelector(selectedModuleIndex);
   let runningModuels;

   if (props.module) {
      const modules = props.module;
      if (Array.isArray(modules)) {
         runningModuels = modules[moduleIndex];
      } else {
         runningModuels = modules;
      }
   }
   const scratchPadRecord = isNewAPI
      ? scratchPad.ScratchPadRecordsList
      : scratchPad.scratchPadRecord;
   var currentProgress;
   try {
      const fiterData = scratchPadRecord.filter(data => {
         const parseIndex = parseInt(moduleIndex) + 1;
         const parseModuleNumber = parseInt(data.ModuleNumber);
         logger('filter', {value: parseModuleNumber == parseIndex});
         return parseModuleNumber == parseIndex;
      });
      if (fiterData[0].ModuleCompleted != 1) {
         const mPageNumber = fiterData[0].ModulePageNumber;
         copiedObject.pageNumber = mPageNumber;
         if (runningModuels && copiedObject.pageCount == 0) {
            copiedObject.pageCount =
               runningModuels?.ModuleSlides?.CourseModuleSlide?.length;
         }
      }
      currentProgress = getCourseProgressLevel(
         copiedObject,
         width * 0.4 - 16 * 2,
      );
   } catch (error) {
      currentProgress = getCourseProgressLevel(item, width * 0.4 - 16 * 2);
   }

   return (
      <View
         style={[
            styles.headerContainer,
            {
               marginHorizontal: isLandscape ? 24 : 16,
               marginTop: isLandscape ? 30 : 0,
               ...Platform.select({
                  web: {
                     backgroundColor: 'transparent',
                  },
               }),
            },
         ]}>
         {/** Header button section having Exit, Reset and unlock */}
         {/** Header description Section */}
         <View
            style={[
               styles.headerDescriptionContainer,
               {
                  width: isLandscape ? width * 0.4 : width,
                  ...Platform.select({
                     web: {
                        width: !isLandscape ? '40%' : '100%',
                        backgroundColor: 'transparent',
                     },
                  }),
               },
            ]}>
            {/** Header module icons sections */}
            <View
               style={{
                  flexDirection: 'row',
               }}>
               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/course_hightlight_24.png')}
                     style={styles.moduleIconLandscape}
                  />
                  <Text
                     style={[
                        styles.moduleDescription,
                        {fontSize: !isLandscape ? 10 : 12},
                     ]}>
                     {moduleLevel}
                  </Text>
               </View>

               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/Timer.png')}
                     style={styles.moduleIconLandscape}
                  />
                  <Text
                     style={[
                        styles.moduleDescription,
                        {fontSize: !isLandscape ? 10 : 12},
                     ]}>
                     {hourLevel}
                  </Text>
               </View>
               <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Image
                     source={require('../../assets/Check.png')}
                     style={styles.moduleIconLandscape}
                  />
                  <Text
                     style={[
                        styles.moduleDescription,
                        {fontSize: !isLandscape ? 10 : 12},
                     ]}>
                     {courseValidityLevel}
                  </Text>
               </View>
            </View>

            {/** Title and progress section */}
            <View
               style={{
                  flex: 1,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                  width: isLandscape ? width * 0.4 : width,
                  height: height * 0.1 * 0.8,
                  ...Platform.select({
                     web: {
                        width: isLandscape ? '100%' : '40%',
                     },
                  }),
               }}>
               <View
                  style={{
                     width: !isLandscape ? width * 0.6 : width * 0.6 * 0.4,
                     marginTop: 0,
                     ...Platform.select({
                        web: {
                           width: !isLandscape ? '50%' : '62%',
                        },
                     }),
                  }}>
                  <Text
                     style={[
                        styles.availableModuleTitle,
                        {fontSize: !isLandscape ? 16 : 20},
                        isLandscape && {paddingTop: 16},
                     ]}>
                     {'Available Modules'}
                  </Text>
                  <Text style={styles.moduleAvailableDescription}>
                     {
                        'Please select a module to begin or continue with your training'
                     }
                  </Text>
               </View>

               <View
                  style={{
                     width: !isLandscape
                        ? width * 0.3 - 20
                        : width * 0.4 * 0.3 - 25,
                     marginTop: 0,
                     justifyContent: 'center',
                     alignItems: 'center',
                     flexDirection: 'row',
                     ...Platform.select({
                        web: {
                           width: !isLandscape ? '50%' : '38%',
                           alignItems: 'center',
                           justifyContent: 'flex-end',
                        },
                     }),
                  }}>
                  <View
                     style={{
                        width: !isLandscape
                           ? width * 0.3 - 20
                           : width * 0.4 * 0.3 - 25,
                        marginTop: 0,
                        justifyContent: 'center',
                        alignItems: 'flex-end',
                        ...Platform.select({
                           web: {
                              width: null,
                           },
                        }),
                     }}>
                     <View>
                        <Text
                           style={[
                              styles.moduleCompletedCount,
                              {
                                 fontSize: !isLandscape ? 20 : 32,
                                 width: isLandscape ? '100%' : '50%',
                                 ...Platform.select({
                                    web: {
                                       width: isLandscape ? '100%' : '50%',
                                       textAlign: isLandscape
                                          ? 'center'
                                          : 'inherit',
                                    },
                                 }),
                              },
                           ]}>
                           {item.modulesCompleted}/{item.coursemodulecount}
                        </Text>
                        <Text
                           style={[
                              styles.moduleCompleted,
                              {fontSize: !isLandscape ? 8 : 10},
                              {
                                 ...Platform.select({
                                    web: {
                                       width: isLandscape ? '100%' : '50%',
                                       textAlign: isLandscape
                                          ? 'center'
                                          : 'inherit',
                                    },
                                 }),
                              },
                           ]}>
                           {'Module Completed'}
                        </Text>
                     </View>
                  </View>

                  <View
                     style={{
                        width: !isLandscape ? width * 0.1 : width * 0.5 * 0.1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...Platform.select({
                           web: {
                              width: null, //!isLandscape ? '25%' : null,
                              alignItems: 'flex-end',
                           },
                        }),
                     }}>
                     {/* <AnimatedCircularProgress
                     size={!isLandscape ? 40 : 56}
                     width={4}
                     fill={mPercent}
                     rotation={0}
                     tintColor="#26E555"
                     backgroundColor="#1C222B">
                     {fill => (
                        <View
                           style={{
                              width: '100%',
                              height: '100%',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: '#1C222B',
                              opacity: 0.6,
                           }}>
                           <Image
                              source={require('../../assets/course_hightlight_24.png')}
                              style={{width: 24, height: 26}}
                           />
                        </View>
                     )}
                  </AnimatedCircularProgress> */}
                     <UICircularProgress
                        size={!isLandscape ? 40 : 56}
                        width={12}
                        fill={mPercent}
                        rotation={0}
                        tintColor="#26E555"
                        trailStroke="#1C222B"
                        backgroundColor="#1C222B"
                        background={true}
                        img={require('../../assets/course_hightlight_24.png')}
                        imgWidth={24}
                        imgHeight={26}
                        showPercent={false}
                        trailOpacity={0}
                     />
                  </View>
               </View>
            </View>
            <View
               style={{
                  width: width * 0.4 - 16 * 2,
                  marginRight: 16,
                  background: 'rgba(217, 217, 217, 8)',
                  borderRadius: 10,
                  borderWidth: 0.25,
                  borderColor: 'lightgray',
                  marginTop: 30,
                  marginBottom: 11,
                  ...Platform.select({
                     web: {
                        width: null,
                        marginRight: 0,
                        height: 8,
                     },
                  }),
               }}>
               <View
                  style={{
                     width: currentProgress,
                     height: 7,
                     backgroundColor: '#26E555',
                     borderRadius: 10,
                     justifyContent: 'center',
                     ...Platform.select({
                        web: {
                           width: `${
                              (currentProgress / (width * 0.4 - 16 * 2)) * 100
                           }%`,
                           maxWidth: '100%',
                        },
                     }),
                  }}
               />
            </View>
         </View>
         {/** Spacer View */}
         <View
            style={{
               width: !isLandscape ? width : width * 0.4,
               height: 10,
               backgroundColor: coureListGradientColorUpper,
               ...Platform.select({
                  web: {
                     height: 5,
                     width: '100%',
                     backgroundColor: 'transparent',
                  },
               }),
            }}
         />
      </View>
   );
};

const CourseDetails = props => {
   const dispatch = useDispatch();
   const jsonData = JSON.parse(props.parseJson);
   const [isDownloadStart, setDownloadStart] = useState(false);
   const [validOrientationWeb, setValidOrientationWeb] = useState(true);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const showLandscapeMsg = useSelector(getShowLandscapeMsg);
   const isTabletPortraitMode = useSelector(getIsTabletPortrait);
   const [isExitHover, setExitHover] = useState(false);
   const [isResetHover, setResetHover] = useState(false);
   const [isUnlockHover, setUnlockHover] = useState(false);
   const [isCourseSupportHover, setCourseSupportHover] = useState(false);
   const [isResourceHover, setResourceHover] = useState(false);
   const [isRefreshHeader, setRefreshHeader] = useState(false);
   const isScreenFocus = useIsFocused();

   useEffect(() => {
      if (isWeb) {
         setValidOrientationWeb(
            !(
               showLandscapeMsg &&
               (isLandscapeSmallWebView || isTabletPortraitMode)
            ),
         );
      }
      setRefreshHeader(isScreenFocus);
   }, [
      isLandscapeSmallWebView,
      showLandscapeMsg,
      isTabletPortraitMode,
      isScreenFocus,
   ]);
   // // Sidharth: Below code was commented because it was causing infinite-render issue
   // var module;
   // if (Array.isArray(jsonData?.DataSet.courseModule?.CourseModule)) {
   //    module = jsonData?.DataSet.courseModule?.CourseModule;
   // } else {
   //    module = [jsonData?.DataSet.courseModule?.CourseModule];
   // }

   // //saving ques/ans data here
   // var reviewQuesAns;
   // if (Array.isArray(jsonData?.DataSet?.courseTestModule?.CourseTestModule)) {
   //    reviewQuesAns = jsonData?.DataSet?.courseTestModule?.CourseTestModule;
   // } else {
   //    reviewQuesAns = [jsonData?.DataSet?.courseTestModule?.CourseTestModule];
   // }
   // const reviewQuesAnswer = {reviewQuestionAnswerData: reviewQuesAns};
   // dispatch(setReviewQuestionAnswer(reviewQuesAnswer));

   // const courseId = {courseId: jsonData.DataSet.courseGeneralData.CourseIDCode};
   // dispatch(setCourseId(courseId));
   // // Sidharth: Below code inside useEffect is replacement of above commented code
   const [module, setModule] = useState(null);

   useEffect(() => {
      let module;
      if (Array.isArray(jsonData?.DataSet.courseModule?.CourseModule)) {
         module = jsonData?.DataSet.courseModule?.CourseModule;
      } else {
         module = [jsonData?.DataSet.courseModule?.CourseModule];
      }
      if (Array.isArray(module)) {
         setModule(module);
      }
      let reviewQuesAns;
      if (
         Array.isArray(jsonData?.DataSet?.courseTestModule?.CourseTestModule)
      ) {
         reviewQuesAns = jsonData?.DataSet?.courseTestModule?.CourseTestModule;
      } else {
         reviewQuesAns = [
            jsonData?.DataSet?.courseTestModule?.CourseTestModule,
         ];
      }
      const reviewQuesAnswer = {reviewQuestionAnswerData: reviewQuesAns};

      dispatch(setReviewQuestionAnswer(reviewQuesAnswer));

      const courseId = {
         courseId: jsonData.DataSet.courseGeneralData.CourseIDCode,
      };

      dispatch(setCourseId(courseId));
   }, []);

   const trainingItem = props.couseItem;
   const navigation = useNavigation();
   const isLandscapemode = useSelector(selectScreenOrientation);
   // logger('orientatin value :' + isLandscapemode);
   const [popoverVisible, setPopoverVisible] = useState(false);
   const [downloadProgress, setDownloadProgress] = useState(0);
   const [anchorView, setAnchorView] = useState({x: 0, y: 100});
   // Co-ordinates calculations for showing popover
   const [centerX, setCenterX] = useState(0);
   const [centerY, setCenterY] = useState(0);
   const touchableRef = useRef(null);
   const [rowHeights, setRowHeights] = useState({});
   const courseTitle = jsonData.DataSet.courseGeneralData.CourseName;
   const courseShortDescription =
      jsonData.DataSet.courseGeneralData.CourseDescription;
   const resourcesDataSource =
      jsonData.DataSet.courseGeneralData.CourseResourceData.CourseResourcesData;
   const [loading, setLoading] = useState(true);

   const isResourcesAvailable = isArrayofJSONObjects(
      jsonData.DataSet.courseGeneralData.CourseResourceData,
   );

   const isSingResource = isSingleJSONNode(JSON.stringify(resourcesDataSource));
   const [isModalActionSheetVisible, setIsModalActionSheetVisible] =
      useState(false);
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const isDemoAccount = useSelector(selectAuthData).DemoAccount;
   const [isApiLoading, setIsApiLoading] = useState(false);
   const loginid = trainingItem.loginid;
   const [isApiLoadingLockAccount, setIsApiLoadingLockAccount] =
      useState(false);
   const authData = useSelector(selectAuthData);

   function isArrayofJSONObjects(obj) {
      const resources = obj.CourseResourcesData;

      if (obj === 'undefined') {
         return false;
      }

      if (Array.isArray(resources)) {
         return resources.every(
            item => typeof item === 'object' && item !== null,
         );
      }

      return false;
   }

   function isSingleJSONNode(jsonString) {
      if (jsonString === 'undefined') {
         return false;
      }

      try {
         const jsonObject = JSON.parse(jsonString);
         return true;
      } catch (error) {}
      return false;
   }

   const handleLayout = () => {
      touchableRef.current?.measure((x, y, width, height, pageX, pageY) => {
         const touchableCenterX = pageX + width / 2;
         const touchableCenterY = pageY + height / 2;
         setCenterX(touchableCenterX);
         setCenterY(touchableCenterY);
      });
   };

   const handleImageLoad = () => {
      setLoading(false);
   };

   const handleResetAction = userID => {
      const reqParms = requestParamsForResetAction(userID);
      logger('req params' + JSON.stringify(reqParms));
      // logger('handleResetAction tapped params: ' + JSON.stringify(userID));
      setIsApiLoading(true);
      apiPostRequest({url: RESET_ACCOUNT, parms: reqParms})
         .then(res => {
            setIsApiLoading(false);
            if (res && (res.success || res.StatusResult === true)) {
               logger('Success Response::' + res.success);
               //For Dashboard data refresh
               dispatch(setIsDashboardRefreshRequired(true));
               const key = trainingItem.courseNameID + '/manifest.xc';
               removeSaveItem(key)
                  .then(res => {
                     if (Platform.OS === 'web') {
                        dispatch(
                           setResponseAlertData({
                              showAlert: true,
                              title: 'Alert!',
                              message:
                                 'Account has been reset. Please navigate back to dashboard and visit the course again to see the changes.',
                              callbackType: 'RESET_ACCOUNT',
                           }),
                        );
                        return;
                     }
                     alertWithCallBack({
                        title: 'Alert!',
                        message:
                           'Account has been reset. Please navigate back to dashboard and visit the course again to see the changes.',
                        callBack: () => {
                           navigation.pop(2);
                           navigation.navigate('DashboardScreen');
                        },
                     });
                  })
                  .catch(err => logger({err}));
            } else if (typeof res === 'string') {
               if (isWeb) {
                  showTokenExpireAlertWeb(res);
               } else {
                  alertWithCallBack({
                     title: 'Alert!',
                     message: res,
                     callBack: () => {},
                  });
               }
            } else {
               alertWithCallBack({
                  title: 'Alert!',
                  message: JSON.stringify(res),
                  callBack: () => {},
               });
            }
         })
         .catch(err => logger({err}));
   };

   const requestParamsForResetAction = userID => {
      if (isNewAPI) {
         const employeeKey = authData.EmployeeKey;
         const reqParms = {
            theData: JSON.stringify({
               EmployeeKey: employeeKey,
               DemoAccount: isDemoAccount,
               UserKey: trainingItem.userKey,
            }),
         };
         return reqParms;
      } else {
         return {userID: userID};
      }
   };

   const requestParamsForUnlockAction = userID => {
      if (isNewAPI) {
         const employeeKey = authData.EmployeeKey;
         const reqParms = {
            theData: JSON.stringify({
               EmployeeKey: employeeKey,
               DemoAccount: isDemoAccount,
               UserKey: trainingItem.userKey,
               CourseKey: trainingItem.courseKey,
            }),
         };
         return reqParms;
      } else {
         return {userID: userID};
      }
   };

   const handleUnlockAction = userID => {
      const reqParms = requestParamsForUnlockAction(userID);
      // logger('handleUnlockAction tapped params: ' + JSON.stringify(userID));
      setIsApiLoadingLockAccount(true);
      apiPostRequest({url: UNLOCK_COURSE, parms: reqParms})
         .then(res => {
            setIsApiLoadingLockAccount(false);
            if (res && (res.success || res.StatusResult === true)) {
               //For Dashboard data refresh
               dispatch(setIsDashboardRefreshRequired(true));
               if (isNewAPI) {
                  logger(
                     'Success Response:: ' + JSON.stringify(res.StatusMessage),
                  );
               } else {
                  logger('Success Response:: ' + JSON.stringify(res.success));
               }
               const key = trainingItem.courseNameID + '/manifest.xc';
               removeSaveItem(key)
                  .then(res => {
                     if (Platform.OS === 'web') {
                        dispatch(
                           setResponseAlertData({
                              showAlert: true,
                              title: 'Alert!',
                              message:
                                 'Account unlocked. Please navigate back to dashboard and visit the course again to see the changes.',
                              callbackType: 'UNLOCK_ACCOUNT',
                           }),
                        );
                        return;
                     }
                     alertWithCallBack({
                        title: 'Alert!',
                        message:
                           'Account unlocked. Please navigate back to dashboard and visit the course again to see the changes.',
                        callBack: () => {
                           navigation.pop(2);
                           navigation.navigate('DashboardScreen');
                        },
                     });
                  })
                  .catch(err => logger({err}));
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + JSON.stringify(res));
               if (isWeb) {
                  showTokenExpireAlertWeb(res);
               } else {
                  alert(res);
               }
            } else {
               logger('Error Response:: ' + JSON.stringify(res));
            }
         })
         .catch(err => logger({err}));
   };

   useEffect(() => {
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      Dimensions.addEventListener('change', handleResize);
      return () => {
         Dimensions.removeEventListener('change', handleResize);
      };
   }, []);

   function saveSelectedModuleIndex(selectedIndex) {
      const selectedModuleIndex = {moduleIndex: selectedIndex};
      dispatch(setModuleIndex(selectedModuleIndex));
   }

   async function handleDownloadAction(fileName) {
      if (Platform.OS === 'web') {
         if (OFFLINE_VIDEO_PATH) {
            const name = fileName + '.zip';
            const url = OFFLINE_VIDEO_PATH + name;

            const downloadLink = document.createElement('a');

            downloadLink.href = url;

            downloadLink.download = name;

            downloadLink.click();
         }
         return;
      }
      if (Platform.OS === 'ios' && Platform.OS === 'android') {
      }
      // const MyModule = BackgroundTask;

      const realPath = RNFS.DocumentDirectoryPath;
      const name = fileName + '.zip';
      // logger('Real path: ' + realPath);
      const url = OFFLINE_VIDEO_PATH + name;
      const filePath = `${realPath}/${name}`;
      RNFS.downloadFile({
         fromUrl: url,
         toFile: filePath,
         background: true,
         progress: res => {
            const progress = res.bytesWritten / res.contentLength;
            const p = progress * 100;
            setDownloadProgress(p);
            // logger(`Progress: ${progress * 100}%`);
         },
      })
         .promise.then(result => {
            setDownloadStart(false);
         })
         .catch(error => {
            logger('Error while downloading', error);
         });
   }

   return (
      <SafeAreaView
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     overflow: 'hidden',
                     flex: null,
                     height: 'inherit',
                     background: `linear-gradient(180deg, ${coureListGradientColorLower} 0%, ${coureListGradientColorMiddle} 50.52%, ${coureListGradientColorUpper} 100%)`,
                  },
               }),
            },
         ]}>
         {!isWeb && (
            <UISvg
               height="100%"
               width="100%"
               x1="0%"
               y1="100%"
               x2="0%"
               y2="100%"
               offset={['100%', '100%', '100%']}
               stopColor={[
                  coureListGradientColorLower,
                  coureListGradientColorMiddle,
                  coureListGradientColorUpper,
               ]}
               stopOpacity={['1', '1', '1']}
            />
         )}
         {/* <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
            <Defs>
               <LinearGradient id="grad" x1="0%" y1="100%" x2="0%" y2="100%">
                  <Stop
                     offset="100%"
                     stopColor={coureListGradientColorLower}
                     stopOpacity="1"
                  />
                  <Stop
                     offset="100%"
                     stopColor={coureListGradientColorMiddle}
                     stopOpacity="1"
                  />
                  <Stop
                     offset="100%"
                     stopColor={coureListGradientColorUpper}
                     stopOpacity="1"
                  />
               </LinearGradient>
            </Defs>
            <Rect width="100%" height="100%" fill="url(#grad)" />
         </Svg> */}

         {/** Button headers for Exit , reset action, resources etc */}
         {!isLandscapemode ? (
            <View style={styles.headerBtnContainer}>
               <View
                  style={{
                     flexDirection: 'row',
                     marginHorizontal: 0,
                     height: 32,
                     marginVertical: 8,
                     justifyContent: 'center',
                     width: '100%',
                     marginLeft: isDemoAccount ? 0 : 8,
                     justifyContent: isDemoAccount ? 'center' : 'flex-start',
                  }}>
                  <TouchableOpacity
                     style={[styles.buttonView]}
                     onPress={() => {
                        props.onExitClick();
                     }}>
                     <Text style={styles.buttonTitle}>{'Exit Course'}</Text>
                  </TouchableOpacity>

                  {/** Demo account button options reset and unlock account */}
                  {isDemoAccount ? (
                     <TouchableOpacity
                        style={[styles.buttonView, {marginHorizontal: 5}]}
                        onPress={() => {
                           handleResetAction(loginid);
                        }}>
                        {isApiLoading ? (
                           <ActivityIndicator
                              size="small"
                              color="white"
                              style={{
                                 position: 'absolute',
                                 top: 0,
                                 bottom: 0,
                                 left: 0,
                                 right: 0,
                                 zIndex: 1,
                              }}
                           />
                        ) : null}
                        <Text style={styles.buttonTitle}>
                           {'Reset Account'}
                        </Text>
                     </TouchableOpacity>
                  ) : null}

                  {isDemoAccount ? (
                     <TouchableOpacity
                        style={styles.buttonView}
                        onPress={() => {
                           handleUnlockAction(loginid);
                        }}>
                        {isApiLoadingLockAccount ? (
                           <ActivityIndicator
                              size="small"
                              color="white"
                              style={{
                                 position: 'absolute',
                                 top: 0,
                                 bottom: 0,
                                 left: 0,
                                 right: 0,
                                 zIndex: 1,
                              }}
                           />
                        ) : null}
                        <Text style={styles.buttonTitle}>
                           {'Unlock Account'}
                        </Text>
                     </TouchableOpacity>
                  ) : null}

                  {isResourcesAvailable || isSingResource ? (
                     <TouchableOpacity
                        onMouseEnter={() => setResourceHover(true)}
                        onMouseLeave={() => setResourceHover(false)}
                        style={[
                           {width: 32, height: 32, marginLeft: 5},
                           styles.buttonView,
                        ]}
                        onPress={() => {
                           //logger('resources Data' + resourcesDataSource);
                           navigation.navigate('CourseResourceContainer', {
                              CourseResources: !isResourcesAvailable
                                 ? [resourcesDataSource]
                                 : resourcesDataSource,
                           });
                        }}>
                        <Image
                           style={{
                              width: 32,
                              height: 32,
                              justifyContent: 'center',
                              // tintColor: isResourceHover
                              //    ? WHITE_ICON_HOVER_TINT_COLOR
                              //    : white,
                           }}
                           source={require('../../assets/resourcesIcon.png')}
                        />
                     </TouchableOpacity>
                  ) : null}
               </View>
            </View>
         ) : (
            <View style={styles.headerBtnContainerLandscape}>
               <View
                  style={{
                     flexDirection: 'row',
                     marginHorizontal: 8,
                     height: 64,
                     marginVertical: 8,
                     justifyContent: 'center',
                     alignItems: 'center',
                     ...Platform.select({
                        web: {
                           height: 'inherit',
                           width: '68%',
                           gap: 8,
                           justifyContent: 'flex-start',
                           flexWrap: 'wrap',
                        },
                     }),
                  }}>
                  {/** Exit Course Action */}
                  <TouchableOpacity
                     onMouseEnter={() => {
                        setExitHover(true);
                     }}
                     onMouseLeave={() => {
                        setExitHover(false);
                     }}
                     style={[styles.buttonView, {height: 48, width: 151}]}
                     onPress={() => {
                        props.onExitClick();
                     }}>
                     <View
                        style={{
                           flexDirection: 'row',
                           justifyContent: 'center',
                           alignItems: 'center',
                        }}>
                        <Image
                           source={require('../../assets/arrowCircleLeft.png')}
                           style={{
                              width: 18,
                              height: 18,
                              tintColor:
                                 isExitHover && WHITE_ICON_HOVER_TINT_COLOR,
                           }}
                        />
                        <Text
                           style={[
                              styles.buttonTitleLandscape,
                              {
                                 color: isExitHover
                                    ? WHITE_TEXT_HOVER_COLOR
                                    : 'white',
                              },
                           ]}>
                           {'Exit Course'}
                        </Text>
                     </View>
                  </TouchableOpacity>

                  {/** Reset Account Action */}
                  {isDemoAccount ? (
                     <TouchableOpacity
                        onMouseEnter={() => {
                           setResetHover(true);
                        }}
                        onMouseLeave={() => {
                           setResetHover(false);
                        }}
                        style={[
                           styles.buttonView,
                           {marginHorizontal: 5, height: 48, width: 175},
                        ]}
                        onPress={() => {
                           handleResetAction(loginid);
                        }}>
                        {isApiLoading ? (
                           <ActivityIndicator
                              size="small"
                              color="white"
                              style={{
                                 position: 'absolute',
                                 top: 0,
                                 bottom: 0,
                                 left: 0,
                                 right: 0,
                                 zIndex: 1,
                              }}
                           />
                        ) : null}
                        <View
                           style={{
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}>
                           <Image
                              source={require('../../assets/reset.png')}
                              style={{
                                 width: 18,
                                 height: 18,
                                 tintColor:
                                    isResetHover && WHITE_ICON_HOVER_TINT_COLOR,
                              }}
                           />
                           <Text
                              style={[
                                 styles.buttonTitleLandscape,
                                 {
                                    color: isResetHover
                                       ? WHITE_TEXT_HOVER_COLOR
                                       : 'white',
                                 },
                              ]}>
                              {'Reset Account'}
                           </Text>
                        </View>
                     </TouchableOpacity>
                  ) : null}

                  {/** Unlock Account Action */}
                  {isDemoAccount ? (
                     <TouchableOpacity
                        onMouseEnter={() => {
                           setUnlockHover(true);
                        }}
                        onMouseLeave={() => {
                           setUnlockHover(false);
                        }}
                        style={[styles.buttonView, {height: 48, width: 184}]}
                        onPress={() => {
                           handleUnlockAction(loginid);
                        }}>
                        {isApiLoadingLockAccount ? (
                           <ActivityIndicator
                              size="small"
                              color="white"
                              style={{
                                 position: 'absolute',
                                 top: 0,
                                 bottom: 0,
                                 left: 0,
                                 right: 0,
                                 zIndex: 1,
                              }}
                           />
                        ) : null}
                        <View
                           style={{
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}>
                           <Image
                              source={require('../../assets/unlock.png')}
                              style={{
                                 width: 18,
                                 height: 18,
                                 tintColor:
                                    isUnlockHover &&
                                    WHITE_ICON_HOVER_TINT_COLOR,
                              }}
                           />
                           <Text
                              style={[
                                 styles.buttonTitleLandscape,
                                 {
                                    color: isUnlockHover
                                       ? WHITE_TEXT_HOVER_COLOR
                                       : 'white',
                                 },
                              ]}>
                              {'Unlock Account'}
                           </Text>
                        </View>
                     </TouchableOpacity>
                  ) : null}

                  {isDownloadAllowed() ? (
                     <TouchableOpacity
                        style={[
                           styles.buttonView,
                           {
                              height: 48,
                              width: 170,
                              marginStart: 5,
                              ...Platform.select({
                                 web: {
                                    marginStart: 0,
                                 },
                              }),
                           },
                        ]}
                        onPress={() => {
                           // setDownloadStart(true);
                           handleDownloadAction(trainingItem.courseNameID);
                        }}>
                        <View
                           style={{
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}>
                           {Platform.OS === 'web' ? (
                              <Image
                                 style={{width: 18, height: 18}}
                                 source={require('../../assets/downloadIcon.png')}
                              />
                           ) : (
                              <UICircularProgress
                                 size={30}
                                 width={8}
                                 fill={downloadProgress}
                                 rotation={0}
                                 tintColor="#ffffff"
                                 onAnimationComplete={() =>
                                    logger('onAnimationComplete')
                                 }
                                 backgroundColor="#939393"
                                 downloadProgress={true}
                                 background={true}
                                 showPercent={true}
                                 onlyPercentage={true}
                                 trailStroke={'#939393'}
                                 percentFont={10}
                              />
                           )}

                           {/* <AnimatedCircularProgress
                  size={30}
                  width={2}
                  fill={downloadProgress}
                  rotation={0}
                  tintColor="#ffffff"
                  onAnimationComplete={() => logger('onAnimationComplete')}
                  backgroundColor="#939393">
                  {fill => (
                    <View>
                      <Text
                        style={{
                          color: white,
                          fontSize: 7,
                          fontWeight: '500',
                          fontFamily: FONT_FAMILY_REGULAR,
                        }}>
                        {`${downloadProgress.toFixed(2)}%`}
                      </Text>
                    </View>
                  )}
                </AnimatedCircularProgress> */}
                           {isDownloadStart ? (
                              <View>
                                 <DownloadThreeDotsLoader title={''} />
                              </View>
                           ) : (
                              <Text style={styles.buttonTitleLandscape}>
                                 {'Download'}
                              </Text>
                           )}
                        </View>
                     </TouchableOpacity>
                  ) : null}

                  {/** Resources list button Action */}
                  {isResourcesAvailable || isSingResource ? (
                     <TouchableOpacity
                        onMouseEnter={() => setResourceHover(true)}
                        onMouseLeave={() => setResourceHover(false)}
                        style={[
                           {
                              width: 48,
                              height: 48,
                              marginLeft: 5,
                              justifyContent: 'center',
                           },
                           styles.buttonView,
                        ]}
                        onPress={() => {
                           navigation.navigate('CourseResourceContainer', {
                              CourseResources: !isResourcesAvailable
                                 ? [resourcesDataSource]
                                 : resourcesDataSource,
                           });
                        }}>
                        <Image
                           style={{
                              width: 48,
                              height: 48,
                              tintColor:
                                 isResourceHover && WHITE_ICON_HOVER_TINT_COLOR,
                           }}
                           source={require('../../assets/resourcesIcon.png')}
                        />
                     </TouchableOpacity>
                  ) : null}
               </View>

               <View
                  style={{
                     flexDirection: 'row',
                     marginHorizontal: 16,
                     height: 64,
                     marginVertical: 8,
                     justifyContent: 'center',
                     alignItems: 'center',
                     ...Platform.select({
                        web: {
                           width: '22%',
                           marginVertical: 0,
                           justifyContent: 'flex-end',
                        },
                     }),
                  }}>
                  {/** Course Support */}
                  <TouchableOpacity
                     onMouseEnter={() => {
                        setCourseSupportHover(true);
                     }}
                     onMouseLeave={() => {
                        setCourseSupportHover(false);
                     }}
                     style={[styles.buttonView, {height: 48, width: 184}]}
                     ref={touchableRef}
                     onLayout={handleLayout}
                     onPress={event => {
                        setAnchorView({x: 530, y: 70});
                        setPopoverVisible(true);
                     }}>
                     <View
                        style={{
                           flexDirection: 'row',
                           justifyContent: 'center',
                           alignItems: 'center',
                        }}>
                        <Image
                           source={require('../../assets/supportIcon.png')}
                           style={{
                              width: 18,
                              height: 18,
                              tintColor:
                                 isCourseSupportHover &&
                                 WHITE_ICON_HOVER_TINT_COLOR,
                           }}
                        />
                        <Text
                           style={[
                              styles.buttonTitleLandscape,
                              {
                                 color: isCourseSupportHover
                                    ? WHITE_TEXT_HOVER_COLOR
                                    : 'white',
                              },
                           ]}>
                           {'Course Support'}
                        </Text>
                     </View>
                  </TouchableOpacity>
               </View>
            </View>
         )}

         {/** Blue header only for landscaped mode for mobile list view header is used  */}
         {!isLandscapemode ? null : (
            <View
               style={[
                  styles.headerTitleContainerLandScape,
                  {
                     ...Platform.select({
                        web: {
                           /* background:
                              'linear-gradient(180deg, #003DA5 100%, #003184 100%)', */
                           background: '#171618',
                           height: '8vh',
                           justifyContent: 'center',
                        },
                     }),
                  },
               ]}>
               {/* <Svg
                  height="100%"
                  width="100%"
                  style={StyleSheet.absoluteFillObject}>
                  <Defs>
                     <LinearGradient
                        id="grad"
                        x1="0%"
                        y1="100%"
                        x2="0%"
                        y2="0%">
                        <Stop
                           offset="100%"
                           stopColor={coureTitleBGGradientColorLower}
                           stopOpacity="1"
                        />
                        <Stop
                           offset="100%"
                           stopColor={coureTitleBGGradientColorUpper}
                           stopOpacity="0"
                        />
                     </LinearGradient>
                  </Defs>
                  <Rect width="100%" height="100%" fill="url(#grad)" />
               </Svg> */}
               {/* <UISvg
                  height="100%"
                  width="100%"
                  x1="0%"
                  y1="100%"
                  x2="0%"
                  y2="0%"
                  offset={['100%', '100%']}
                  stopColor={['#003DA5', '#003184']}
                  stopOpacity={['1', '0']}
               /> */}
               <View
                  style={{
                     width: '100%',
                     paddingTop: 40,
                     paddingBottom: 40,
                     paddingLeft: 32,
                     paddingRight: 16,
                     flexDirection: 'row',
                     alignItems: 'center',
                  }}>
                  <View style={{flex: 0.95}}>
                     <Text style={styles.courseTitleLandscape}>
                        {courseTitle}
                     </Text>
                     <Text style={styles.courseDescriptionLandscape}>
                        {courseShortDescription}
                     </Text>
                  </View>
               </View>
            </View>
         )}

         {/* List view container*/}
         <View
            style={{
               flex: 1,
               flexDirection: 'row',
               ...Platform.select({
                  web: {
                     flex: null,
                     height: !isLandscapemode
                        ? isLandscapeSmallWebView
                           ? '90%'
                           : windowDimensions?.height > 0
                           ? windowDimensions.height - 120
                           : '85vh'
                        : '100vh',
                     minHeight: isLandscapeSmallWebView ? '100vh' : null,
                     marginBottom: 0,
                     paddingBottom: 1,
                  },
               }),
            }}>
            {/** Landscape mode have 40% width and Portrait mode occupy whole width */}
            <View
               style={{
                  width: isLandscapemode ? '40%' : '100%',
                  flex: 1,
                  maxHeight: validOrientationWeb ? null : '100vh',
                  ...Platform.select({
                     web: {
                        flex: null,
                        width: isLandscapemode ? '45%' : '100%',
                        minWidth: isLandscapemode ? 400 : null,
                        height: '100%',
                        paddingBottom: 4,
                     },
                  }),
               }}>
               <CourseDetailList
                  ItemSeparatorComponent={props => {
                     // here you can access the trailingItem with props.trailingItem
                     return (
                        <View
                           style={{
                              height: 8,
                           }}
                        />
                     );
                  }}
                  ListHeaderComponent={
                     !isLandscapemode ? (
                        <Header
                           onExitClick={props.onExitClick}
                           trainingItem={trainingItem}
                           title={courseTitle}
                           description={courseShortDescription}
                           isRefresh={isRefreshHeader}
                           module={module}
                        />
                     ) : (
                        <HeaderLandScape
                           onExitClick={props.onExitClick}
                           trainingItem={trainingItem}
                           isLandscape={isLandscapemode}
                           isRefresh={isRefreshHeader}
                           module={module}
                        />
                     )
                  }
                  data={module}
                  getItemLayout={(data, index) => ({
                     length: rowHeights[index],
                     offset: rowHeights[index] * index,
                     index,
                  })}
                  height={undefined}
                  renderItem={({
                     item,
                     iconTintColor,
                     titleColor,
                     isSelected,
                     index,
                  }) => (
                     <CourseDetailItem
                        icon={item.icon}
                        title={item.CourseModuleName}
                        ModuleSlidesCount={
                           Array.isArray(item?.ModuleSlides?.CourseModuleSlide)
                              ? item?.ModuleSlides?.CourseModuleSlide?.length
                              : 1
                        }
                        iconTintColor={iconTintColor}
                        titleColor={titleColor}
                        isSelected={isSelected}
                        index={index}
                        locked={!item.ModuleAvailable}
                        isCourseModuleCompleted={item.CourseModuleComplete}
                        isLandscape={isLandscapemode}
                        isPreTestEnable={canPreTest({cm: item})}
                        preTestInitiat={pretest => {
                           props.onRowSelected({
                              item: item,
                              pretest: pretest,
                              index: index,
                           });
                        }}
                     />
                  )}
                  keyExtractor={item => item.id}
                  onSelect={item => {
                     if (item.ModuleAvailable) {
                        saveSelectedModuleIndex(item.CourseModuleID);
                        props.onRowSelected({
                           item: item,
                           pretest: false,
                           index: item.CourseModuleID,
                        });
                     }
                  }}
               />
            </View>

            {/* Image container in right side occupying 60% space only for landscape mode*/}
            {!isLandscapemode ? null : (
               <View
                  style={{
                     height: '100%',
                     width: '60%',
                     ...Platform.select({
                        web: {
                           width: '55%',
                           height: '100%',
                        },
                     }),
                  }}>
                  {loading && (
                     <ActivityIndicator
                        size="large"
                        color="white"
                        style={{
                           position: 'absolute',
                           top: 0,
                           bottom: 0,
                           left: 0,
                           right: 0,
                           zIndex: 1,
                        }}
                     />
                  )}
                  <ImageBackground
                     style={styles.bgImage}
                     source={{uri: trainingItem.coursethumbnail}}
                     onLoadEnd={handleImageLoad}
                  />
               </View>
            )}
         </View>

         {/* Customer support option is at bottom on mobile and at top right corner on other platforms*/}
         {!isLandscapemode ? (
            <View
               style={[
                  styles.lowerView,
                  {
                     ...Platform.select({
                        web: {
                           height: 72,
                           bottom: 0,
                        },
                     }),
                  },
               ]}>
               <TouchableOpacity
                  style={styles.courseSupportButtonView}
                  onPress={event => {
                     //logger('show popover');
                     //setAnchorView({x: 16, y: event.nativeEvent.pageY - 285});
                     // setPopoverVisible(true);
                     setIsModalActionSheetVisible(true);
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                     }}>
                     <Image
                        source={require('../../assets/warningIcon.png')}
                        style={{width: 18, height: 18}}
                     />
                     <Text style={styles.courseButtonTitle}>
                        {'Course Support'}
                     </Text>
                  </View>
               </TouchableOpacity>
            </View>
         ) : null}

         {/** Transparent popver view for customer support on Tablet mode and Actionsheet for mobile */}
         {validOrientationWeb ? ( // only show when device is in valid orientation
            !isLandscapemode && isModalActionSheetVisible ? (
               <ActionSheetCourseSupport
                  visible={isModalActionSheetVisible}
                  onclose={() => {
                     setIsModalActionSheetVisible(false);
                  }}
               />
            ) : (
               <PopoverLandscape
                  visible={popoverVisible}
                  anchorView={{x: 0, y: 0}}
                  onclose={() => {
                     setPopoverVisible(false);
                  }}
                  width={windowDimensions.width}
                  height={windowDimensions.height}
                  content={
                     <CourseSupport
                        top={80}
                        isLandscapeOrientation={isLandscapemode}
                     />
                  }
               />
            )
         ) : null}
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      // backgroundColor: courseListBGColor,
   },
   upperView: {
      width: '100%',
      height: '50%',
      backgroundColor: downloadViewColor,
      justifyContent: 'center',
      alignItems: 'center',
   },
   headerContainer: {
      flex: 1,
      backgroundColor: drawerListBackgroundColor,
   },
   headerBtnContainer: {
      width: '100%',
      height: 48,
      backgroundColor: drawerListBackgroundColor,
   },
   headerBtnContainerLandscape: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: drawerListBackgroundColor,
   },
   buttonView: {
      backgroundColor: couurseDetailButtonColor,
      minHeight: 32,
      borderRadius: 6,
      justifyContent: 'center',
   },
   buttonTitle: {
      color: 'white',
      fontSize: 12,
      fontWeight: '700',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginHorizontal: 10,
   },
   buttonTitleLandscape: {
      color: 'white',
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginHorizontal: 10,
   },
   headerTitleContainer: {
      flex: 1,
      backgroundColor: '#003DA5',
   },
   headerTitleContainerLandScape: {
      width: '100%',
      minHeight: 135, //height * 0.12,
      backgroundColor: '#003DA5',
      // justifyContent: 'space-between',
      // alignItems: 'center',
   },
   headerLogo: {
      width: 119,
      height: 16,
      marginLeft: 16,
      marginVertical: 15,
   },
   headerLogoLandscape: {
      width: 237,
      height: 32,
   },
   courseTitle: {
      color: 'white',
      fontSize: 20,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_MEDIUM,
   },
   courseDescription: {
      color: 'white',
      fontSize: 12,
      fontWeight: '500',
      fontFamily: FONT_FAMILY_REGULAR,
      marginTop: 3,
      marginBottom: 5,
   },
   courseTitleLandscape: {
      color: 'white',
      fontSize: 24,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_MEDIUM,
   },
   courseDescriptionLandscape: {
      color: 'white',
      fontSize: 14,
      fontWeight: '400',
      fontFamily: FONT_FAMILY_REGULAR,
      marginTop: 8,
   },
   headerDescriptionContainer: {
      backgroundColor: 'transparent',
   },
   moduleDescription: {
      fontSize: 8,
      fontWeight: '400',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginLeft: 5,
      marginRight: 8,
   },
   moduleIcon: {
      width: 12,
      height: 12,
      resizeMode: 'contain',
   },
   moduleIconLandscape: {
      width: 16,
      height: 16,
      resizeMode: 'contain',
   },
   availableModuleTitle: {
      fontSize: 16,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
   },

   availableModulePortraitTitle: {
      fontSize: 16,
      fontWeight: '400',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
   },

   moduleAvailableDescription: {
      fontSize: 10,
      fontWeight: '400',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginTop: 4,
   },
   moduleCompletedCount: {
      fontSize: 20,
      fontWeight: '400',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginTop: 4,
      textAlign: 'center',
   },
   moduleCompleted: {
      fontSize: 8,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      paddingleft: 8,
      marginTop: 3,
      textAlign: 'center',
   },
   headerImageContainer: {
      width: '100%',
      // minHeight: '20%',
   },
   bgImage: {
      position: 'absolute',
      resizeMode: 'cover',
      width: '100%',
      height: '100%',
   },
   lowerView: {
      width: '100%',
      height: '8%',
      backgroundColor: 'transparent',
      justifyContent: 'center',
      alignItems: 'center',
      ...Platform.select({
         web: {
            backgroundColor: courseDesciptionContainerColor,
         },
      }),
   },
   courseSupportButtonView: {
      backgroundColor: 'white',
      minHeight: 40,
      borderRadius: 6,
      borderWidth: 2,
      borderColor: primaryColor500,
      justifyContent: 'center',
      marginHorizontal: 16,
      width: width - 32,
      ...Platform.select({
         web: {
            width: '92%',
         },
      }),
   },
   courseButtonTitle: {
      color: primaryColor500,
      fontSize: 12,
      fontWeight: '700',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_REGULAR,
      marginHorizontal: 10,
   },
});

export default CourseDetails;
